export var buildParentFilter = function (settings) {
    var selectedPlatformIds = [];
    var setting = {};
    setting.publisherIds = settings.publisherIds;
    if (settings.medias) {
        var mediaIds = settings.medias.map(function (media) { return media.id; });
        setting.mediaIds = mediaIds;
    }
    if (settings.labels) {
        var labelIds = settings.labels.map(function (label) { return label.id; });
        setting.labelIds = labelIds;
    }
    if (settings.platformGroups) {
        setting.platformGroupIds = settings.platformGroupIds;
        settings.platformGroups.forEach(function (platformGroup) {
            if (platformGroup && platformGroup.selectedPlatformList) {
                var platformList = platformGroup.selectedPlatformList;
                var platformIds = platformList.map(function (platform) { return platform.platformId; });
                selectedPlatformIds.push.apply(selectedPlatformIds, platformIds);
            }
        });
    }
    if (settings.pubdeskInventories) {
        var pubdeskInventoryIds = settings.pubdeskInventories.map(function (inventory) { return inventory.id; });
        setting.inventoryIds = pubdeskInventoryIds;
    }
    if (settings.independentPlatforms) {
        var independentPlatformIds = settings.independentPlatforms.map(function (platform) { return platform.id; });
        selectedPlatformIds.push.apply(selectedPlatformIds, independentPlatformIds);
    }
    setting.platformIds = selectedPlatformIds;
    return setting;
};
